import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n';
import i18next from 'i18next';
// 加载公用样式
import '@/style/flex.scss';
import '@/style/element.scss';
import '@/style/common.scss';
import '@/style/addDataFrom.scss';
import router from './router';

Vue.config.productionTip = false

// es6语法兼容ie浏览器
import "babel-polyfill";

//工具类
import utils from './utils/utils.js';
utils.getUserInfo();
Vue.prototype.$utils = utils;

// 注册多语言
import zhCN from './i18n/zh-CN'; //中文
import en from './i18n/en'; //英文
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  messages: {
    'zh-CN': zhCN,
    'en': en
  }
});
// i18n.mergeLocaleMessage
i18next.init({
  lng: 'zh-CN',
  resources: {}
});

// 新增国际化文本
Vue.prototype.mergeLang = function(path) {
  const languageList = utils.getLanguageList();
  languageList.forEach((languageItem) => {
    let newMessages = require("@/i18n/" + path + "/" + languageItem.key) || {}
    Vue.prototype.bus.$i18n.mergeLocaleMessage(languageItem.key, newMessages)
  });
}

//注册element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

//自定义scrollView
import scrollView from '@/components/scrollView/scrollView.vue';
Vue.component("scrollView", scrollView);

//无数据布局
import viewNoData from '@/components/view-noData.vue';
Vue.component("view-noData", viewNoData);

//弹出框插件
import * as loadingDialog from '@/utils/loadingDialog.js'; // 全局vue filter
Object.keys(loadingDialog).forEach(key => {
  Vue.prototype["$" + key] = loadingDialog[key];
});

//过滤器
import * as filters from '@/filters'; // 全局vue filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

// 自定义指令
import * as directive from '@/directive';
Object.keys(directive).forEach(key => {
  Vue.directive(directive[key].name, directive[key].callback);
});

//网络请求插件
import {
  request
} from '@/utils/httpRequest.js';
request.init();
Vue.prototype.$request = request;

router.beforeEach(function(to, from, next) {
  if (to.path == "/") {
    if (!utils.isLogin()) {
      next({
        name: "login"
      });
    } else {
      next({
        name: "tab"
      });
    }
  } else if (to.meta.isLoginAuthority && !utils.isLogin()) { //检测该接口是否需要登录
    next({
      name: "login"
    });
  } else {
    next();
  }
});
router.afterEach(function(to, from) {
  let isHiddenMenuList = false;
  if (to.meta && to.meta.isHiddenMenuList) {
    isHiddenMenuList = true;
  }
  if (Vue.prototype.$tabSelf) {
    Vue.prototype.$tabSelf.isHiddenMenuList = isHiddenMenuList;
  }
});

new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App
  },
  template: '<App/>',
  beforeCreate() {
    Vue.prototype.bus = this;
  }
});



// WEBPACK FOOTER //
// ./src/main.js